module.exports = __webpack_public_path__ + "img/twitter-square.99937442.svg";